export const actionTypes = {
  SET_MESSAGE: "SET_MESSAGE",
  SET_PRODUCT_LIST: "SET_PRODUCT_LIST",
  SET_PRODUCT_DETAIL: "SET_PRODUCT_DETAIL",
  SET_SUITE_LIST: "SET_SUITE_LIST",
  SET_CATEGORY_LIST: "SET_CATEGORY_LIST",
  SET_PRODUCT_SUITE: "SET_PRODUCT_SUITE",
  SET_CASE: "SET_CASE",
  SET_SOLUTION: "SET_SOLUTION",
  SET_SOLUTION_LIST: "SET_SOLUTION_LIST",
  SET_SOLUTION_DETAIL: "SET_SOLUTION_DETAIL",
  SET_PRODUCT_CLASSIFY_LIST: "SET_PRODUCT_CLASSIFY_LIST",
  SET_MAJOR_UPGRADE_LIST: "SET_MAJOR_UPGRADE_LIST",
  SET_PROJECT_CHANGE_LIST: 'SET_PROJECT_CHANGE_LIST',
  SET_PROMOTION_LIST: 'SET_PROMOTION_LIST',
  SET_SAVE_PAGE_INFO: 'SET_SAVE_PAGE_INFO',
  SET_SOLUTION_LEVEL_ONE: "SET_SOLUTION_LEVEL_ONE",
  SET_SOLUTION_LEVEL_TWO: "SET_SOLUTION_LEVEL_TWO",
  SET_SOLUTION_HISTORY_SET: "SET_SOLUTION_HISTORY_SET",
  SET_PRODUCT_CASE_AREA_LIST: "SET_PRODUCT_CASE_AREA_LIST",
};